export default {
  apiKey: "AIzaSyCxxy2DJ8fmiwZRUBJ_KXGm4WeGcnxS-Ms",
  authDomain: "rn-memart-lib.firebaseapp.com",
  projectId: "rn-memart-lib",
  storageBucket: "rn-memart-lib.firebasestorage.app",
  messagingSenderId: "489593045117",
  appId: "1:489593045117:web:5029bd1143f65e1467f114",
  measurementId: "G-SN6TY4B6FX",
};
